import Vue from "vue";
import moment from "moment";

Vue.filter("hhmm", function (value) {
  if (!value) return "";
  value = value.toString();
  return moment(value, ["HH:mm:ss"]).format("hh:mm A");
});

// Date format: DD/MM/YYYY (Indian standard format with slashes)
Vue.filter("ddmmyyyy", function (value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("DD/MM/YYYY");
});

// Alias for date formatting
Vue.filter("dateFormat", function (value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("DD/MM/YYYY");
});

// DateTime format: DD/MM/YYYY HH:mm
Vue.filter("dateTimeFormat", function (value) {
  if (!value) return "";
  value = value.toString();
  return moment(value).format("DD/MM/YYYY HH:mm");
});
